export const translateWithFallback = (
    translate,
    key,
    fallback = '',
    options,
    hasTranslation
) => {
    if (
        typeof translate !== 'function' ||
        !key ||
        (typeof hasTranslation === 'function' && !hasTranslation(key))
    ) {
        return fallback;
    }

    const translated = translate(key, options);

    if (
        translated === undefined ||
        translated === null ||
        translated === '' ||
        translated === key
    ) {
        return fallback;
    }

    return translated;
};
